import React from "react";
//import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import AddIcon from "@material-ui/icons/Add";
import FileCopyIcon from "@material-ui/icons/FileCopy";
// import DeleteForeverIcon from "@material-ui/icons/DeleteForever";

export const ButtonReusableComponent = ({
  buttonType,
  buttonClass,
  onClick,
  disabled,
  buttonText,
}) => {
  return (
    <React.Fragment>
      <button
        type={buttonType}
        className={
          buttonClass === "login"
            ? "reusableButton-NotActive"
            : null || buttonClass === "activeLogin"
            ? "reusableButton-Active"
            : null || buttonClass === "green"
            ? "reusableButton-Green"
            : null || buttonClass === "red"
            ? "reusableButton-red"
            : null || buttonClass === "simpleLight"
            ? "reusableButton-simple-light"
            : null || buttonClass === "simpleRed"
            ? "reusableButton-simple-red"
            : null
        }
        onClick={onClick}
        disabled={disabled === true ? disabled : false}
      >
        {buttonText}
      </button>
    </React.Fragment>
  );
};

export const IconButtonReusableComponent = ({
  buttonType,
  buttonClass,
  onClick,
  disabled,
  buttonText,
}) => {
  return (
    <React.Fragment>
      <button
        type={buttonType}
        className="reusableicon-button"
        onClick={onClick}
        disabled={disabled === true ? disabled : false}
      >
        {/* <i className="fa fa-plus-circle" aria-hidden="true"></i> */}
        {buttonText}
        <Image
          className="icon-add-button"
          fluid
          src={require("../../../assets/images/ActionImages/addButton.png")}
          alt="Add Button"
          title="Add Button"
        />
      </button>
    </React.Fragment>
  );
};

export const PopupActionButton = ({
  buttonClass,
  buttonType,
  onClick,
  buttonText,
  disabled,
  buttonImage,
  mobile,
}) => {
  return (
    <React.Fragment>
      {" "}
      {buttonImage ? (
        <div onClick={onClick} style={{ textAlign: "center", display: "grid" }}>
          <img src={buttonImage} style={{ width: "50px" }} />
          {buttonText}
        </div>
      ) : (
        <>
          {mobile ? (
            <button
              className="n_button_d_status font_10_m popup-cancel-button"
              type="button"
              onClick={onClick}
            >
              {buttonText}
            </button>
          ) : (
            <button
              className={
                buttonClass === "smallcancel"
                  ? "n_button_d_status font_18_m popup-cancel-button"
                  : null || buttonClass === "smallsave"
                  ? "n_button_d_status font_18_m popup-save-button"
                  : null || buttonClass === "smallblue"
                  ? "n_button_d_status font_18_m popup-blue-button"
                  : null || buttonClass === "cancel"
                  ? "n_button_d_status font_18_m popup-cancel-button"
                  : null || buttonClass === "save"
                  ? "n_button_d_status font_18_m popup-save-button"
                  : null || buttonClass === "bigbuttongreen"
                  ? "reusable-popup-yesandNo-button popup-save-button"
                  : null || buttonClass === "bigbuttonred"
                  ? "reusable-popup-yesandNo-button popup-cancel-button"
                  : null || buttonClass === "bigbuttongray"
                  ? "reusable-popup-yesandNo-button popup-gray-button"
                  : null || buttonClass === "yesButton"
                  ? "onboarding_button_link_reusable onboarding_button_link_reusable_red"
                  : null || buttonClass === "noButton"
                  ? "onboarding_button_link_reusable onboarding_button_link_reusable_white"
                  : null
              }
              disabled={disabled}
              type={buttonType}
              onClick={onClick}
            >
              {buttonText}
            </button>
          )}
        </>
      )}
    </React.Fragment>
  );
};

export const PopupInsideButton = ({
  buttonClass,
  buttonType,
  onClick,
  buttonText,
  display,
  buttonImage,
  title,
  imgStyle,
}) => {
  return (
    <React.Fragment>
      <div className={buttonClass} type={buttonType} onClick={onClick}>
        <div className="row justify-content-center px-2">
          {display === true ? (
            <div className="col-5 text-right">
              <Image
                fluid
                src={buttonImage}
                style={imgStyle}
                alt="filter"
                title={title}
                className="small-image"
              />
            </div>
          ) : null}
          <div className={display === true ? "col-7 text-left" : ""}>
            {buttonText}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export const AddButtonIconComponent = ({
  onClick,
  buttonText,
  fontIcon,
  colorCss,
  displayIcon,
  type,
  disabled,
}) => {
  return (
    <button
      type={type || 'button'}
      className={
        colorCss === "blue"
          ? "add-button-icon-reusable add-button-icon-reusable-blue"
          : "" || colorCss === "delete"
          ? "add-button-icon-reusable add-button-icon-reusable-gray"
          : "" || colorCss === "red"
          ? "add-button-icon-reusable add-button-icon-reusable-red"
          : "" || colorCss === "dark"
          ? "add-button-icon-reusable add-button-icon-reusable-dark"
          : ""
      }
      disabled={disabled}
      onClick={onClick}
    >
      {/* <div className="icon-box-section"> */}
      {/* <i className={fontIcon} aria-hidden="true"></i> */}
      {colorCss === "delete" ? (
        <i
          style={{ fontSize: "15px" }}
          className={fontIcon}
          aria-hidden="true"
        ></i>
      ) : // <DeleteForeverIcon
      //   style={{
      //     fontSize: 21,
      //     color: "#fff",
      //     backgroundColor: "#A2A2A2",
      //     borderRadius: 24,
      //     marginRight: 5,
      //     padding: 3,
      //     boxShadow: "4, 4, 10, #0000002F",
      //   }}
      // />
      displayIcon === "clone" ? (
        <FileCopyIcon
          style={{
            fontSize: 21,
            padding: 4,
            color: "#fff",
            backgroundColor: "#EE3A23",
            borderRadius: 24,
            marginRight: 5,
            boxShadow: "4, 4, 10, #0000002F",
          }}
        />
      ) : (
        <AddIcon
          style={{
            fontSize: 21,
            color: "#fff",
            backgroundColor:
              colorCss === "blue"
                ? "#2096F2"
                : "" || colorCss === "red"
                ? "#EE3A23"
                : "",
            borderRadius: 24,
            marginRight: 5,
            boxShadow: "4, 4, 10, #0000002F",
          }}
        />
      )}
      {/* </div> */}
      {buttonText}
    </button>
  );
};
